import { getPrettyName } from "@utils/user-utils";
/** Returns the markup assignee member */
export function getMarkupAssigneeMember({
  assignee,
  companyMembers,
  projectMembers
}) {
  // There is a list of assignee IDs. Let's take the name of the first assignee.
  const assigneeId = assignee?.values ? assignee.values[0] : undefined;
  const assigneeCompanyMember = companyMembers.find(member => member.identity === assigneeId);
  const assigneeProjectMember = projectMembers.find(member => member.identity === assigneeId);

  // Give priority to the company level member entity
  return assigneeCompanyMember || assigneeProjectMember;
}

/** Returns the markup assignee name */
export function getMarkupAssigneeName({
  assignee,
  companyMembers,
  projectMembers
}) {
  const assigneeMember = getMarkupAssigneeMember({
    assignee,
    companyMembers,
    projectMembers
  });
  const name = getPrettyName(assigneeMember);
  return name !== "" ? name : undefined;
}

/** Returns the members sorted by name and then email, ignoring case, with the current user first */
export function sortAssigneeMembers(members, currentUserId) {
  return [...members].sort((a, b) => Number(b.identity === currentUserId) - Number(a.identity === currentUserId) || getPrettyName(a).localeCompare(getPrettyName(b), undefined, {
    sensitivity: "base"
  }) || a.email.localeCompare(b.email, undefined, {
    sensitivity: "base"
  }));
}